module.exports = __webpack_public_path__ + "img/gol.20f34385.png";